import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import FlexBox, { flexBoxStyles } from '../Flexbox'
import Button from '../../components/Button'
import prev from '../../images/previousIcon.svg'

export default class Pagination extends React.Component {
  constructor(props) {
    super()

    this.state = {
      visiblePages: this.getVisiblePages(null, props.pages),
    }
  }

  static propTypes = {
    pages: PropTypes.number,
    page: PropTypes.number,
    onPageChange: PropTypes.func,
    previousText: PropTypes.string,
    nextText: PropTypes.string,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.pages !== nextProps.pages) {
      this.setState({
        visiblePages: this.getVisiblePages(null, nextProps.pages),
      })
    }

    this.changePage(nextProps.page + 1)
  }

  filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter((page) => page <= totalPages)
  }

  getVisiblePages = (page, total) => {
    if (total < 7) {
      return this.filterPages([1, 2, 3, 4, 5, 6], total)
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total]
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total]
      } else {
        return [1, 2, 3, 4, 5, total]
      }
    }
  }

  changePage = (page) => {
    const activePage = this.props.page + 1

    if (page === activePage) {
      return
    }

    const visiblePages = this.getVisiblePages(page, this.props.pages)

    this.setState({
      visiblePages: this.filterPages(visiblePages, this.props.pages),
    })

    this.props.onPageChange(page - 1)
  }

  render() {
    const activePage = this.props.page + 1

    const visiblePages = this.getVisiblePages(activePage, this.props.pages)

    return (
      <PaginationRow justify="space-between">
        <FlexBox align="center">
          <Prev alt="" />

          <Button
            aria-label="Przejdź na poprzednią stronę"
            color="plain"
            onClick={() => {
              if (activePage === 1) return
              this.changePage(activePage - 1)
            }}
            disabled={activePage === 1}
            label={this.props.previousText}
            altTag=""
          />
        </FlexBox>
        <FlexBox>
          {visiblePages.map((page, index, array) => {
            return (
              <PageButton
                aria-label={`Przejdź na stronę ${page}`}
                color="plain"
                key={page}
                active={activePage === page}
                onClick={() => this.changePage(page)}
                label={array[index - 1] + 2 < page ? `...${page}` : page}
                altTag=""
              />
            )
          })}
        </FlexBox>
        <FlexBox align="center">
          <Button
            aria-label="Przejdź na następną stronę"
            color="plain"
            onClick={() => {
              if (activePage === this.props.pages) return
              this.changePage(activePage + 1)
            }}
            disabled={activePage === this.props.pages}
            label={this.props.nextText}
            altTag=""
          />
          <Next disabled={activePage === this.props.pages} alt="" />
        </FlexBox>
      </PaginationRow>
    )
  }
}

const PageButton = styled(Button)`
  ${(props) => (props.active ? `opacity: 1` : `opacity:0.8`)}
`

const PaginationRow = styled.div`
  ${flexBoxStyles}
  padding: 0 1%;
`

const Next = styled.img.attrs({
  src: prev,
})`
  ${(props) => props.disabled && `opacity: 0.8`}
  height: 20px;
  transform: rotate(180deg);
`
const Prev = styled.img.attrs({
  src: prev,
})`
  ${(props) => props.disabled && `opacity: 0.8`}
  height: 20px;
`
